@if (corporateTaxEntity$ | async) {
<form [formGroup]="balansEnResultatenRekeningFg">

  <div class="d-flex mb-2" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px;"></div>
    @for (item of balansEnResultatenrekening.controls; track $index; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2">
          <p style="width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin: 0;">{{ item.value.naamVennootschap }}</p>
        </div>
      </div>
    }
  </div>

  @for (section of activaSections; track $index; let isLast = $last) {
    <div [class.pt-3]="$index > 0">
      @for (field of section; track field.controlName) {
        <div class="d-flex" formArrayName="balansEnResultatenrekening">
          <div class="col col-1" style="min-width: 308px"><p>{{ field.label }}</p></div>
          @for (item of balansEnResultatenrekening.controls; track $index; let i = $index) {
            <div [formGroupName]="i">
              <div class="col-2" [formArrayName]="field.controlName">
                <div [formGroupName]="0">
                  <snelstart-ui-number-form-control
                    class="custom-input-150"
                    [prefix]="i === index - 2 ? '€  -' : '€'"
                    [minValue]="item.get('naamVennootschap')?.value === 'Eliminatie' ? 0 : -9999999999999"
                    [maxValue]="item.get('naamVennootschap')?.value === 'Eliminatie' ? getMaxValueForField(field.controlName) : 9999999999999"
                    [showAllDecimals]="false"
                    align="right"
                    formControlName="openingsbalans"
                    [id]="field.controlName"
                    [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
                  </snelstart-ui-number-form-control>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px"><p><b>Totaal activa</b></p></div>
      @for (item of balansEnResultatenrekening.controls; track $index; let i = $index) {
        <div [formGroupName]="i">
          <div class="col-2" formArrayName="totaal">
            <div [formGroupName]="0">
              <snelstart-ui-number-form-control
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150 custom-readonly"
                formControlName="totaalActivaOpen"
                id="totaal"
                prefix="€">
              </snelstart-ui-number-form-control>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</form>
}
